import { html } from "lit";

export const Template = () => html`
    <div class="ux-iws-location-block">
        <img
            class="ux-iws-location-block__image"
            src="mock-assets/images/location-image-large.png"
        />
        <div class="ux-iws-location-block__wrapper">
            <h2 class="ux-text-headline ux-text-headline--big">Standorte</h2>
            <div class="ux-iws-location-block__content-container">
                <div class="ux-iws-location-block__content">
                    <div class="ux-iws-location-block__location-container">
                        <h2
                            class="ux-text-headline ux-text-headline--vast ux-u-text-bold"
                        >
                            DE
                        </h2>
                    </div>
                    <div class="ux-iws-location-block__details-container">
                        <div class="ux-iws-location-block__details">
                            <h5 class="ux-iws-location-block__details-title">
                                TRUMPF GmbH + CO. KG
                            </h5>
                            Johann-Maus-Str. 2<br />
                            71254 Ditzingen<br />
                            Deutschland
                            <br />
                            <br />
                            <a href="tel:+4971563030">Telefon +49 7156 3030</a>
                            <br />
                            <a href="fax:+497156303930309"
                                >Fax +49 7156 303930309</a
                            >
                            <br />
                        </div>
                    </div>
                </div>
            </div>
            <div class="ux-iws-location-block__cta">
                <a href="#" class="ux-button ux-button--green"
                    >Zur Standortsuche</a
                >
            </div>
        </div>
    </div>
`;

export const TemplateMultipleItems = () => html`
    <div class="ux-iws-location-block ux-iws-location-block--multiple">
        <img
            class="ux-iws-location-block__image"
            src="mock-assets/images/location-image-large.png"
        />
        <div class="ux-iws-location-block__wrapper">
            <h2 class="ux-text-headline ux-text-headline--big">Standorte</h2>
            <div class="ux-iws-location-block__content-container">
                <div class="ux-iws-location-block__content">
                    <div class="ux-iws-location-block__location-container">
                        <h2
                            class="ux-text-headline ux-text-headline--vast ux-u-text-bold"
                        >
                            DE
                        </h2>
                    </div>
                    <div class="ux-iws-location-block__details-container">
                        <div class="ux-iws-location-block__details">
                            <h5 class="ux-iws-location-block__details-title">
                                TRUMPF GmbH + CO. KG
                            </h5>
                            Johann-Maus-Str. 2<br />
                            71254 Ditzingen<br />
                            Deutschland
                            <br />
                            <br />
                            <a href="tel:+4971563030">Telefon +49 7156 3030</a>
                            <br />
                            <a href="fax:+497156303930309"
                                >Fax +49 7156 303930309</a
                            >
                            <br />
                        </div>
                    </div>
                </div>
                <div class="ux-iws-location-block__content">
                    <div class="ux-iws-location-block__location-container">
                        <h2
                            class="ux-text-headline ux-text-headline--vast ux-u-text-bold"
                        >
                            DE
                        </h2>
                    </div>
                    <div class="ux-iws-location-block__details-container">
                        <div class="ux-iws-location-block__details">
                            <h5 class="ux-iws-location-block__details-title">
                                TRUMPF GmbH + CO. KG
                            </h5>
                            Johann-Maus-Str. 2<br />
                            71254 Ditzingen<br />
                            Deutschland
                            <br />
                            <br />
                            <a href="tel:+4971563030">Telefon +49 7156 3030</a>
                            <br />
                            <a href="fax:+497156303930309"
                                >Fax +49 7156 303930309</a
                            >
                            <br />
                        </div>
                    </div>
                </div>
            </div>
            <div class="ux-iws-location-block__cta">
                <a href="#" class="ux-button ux-button--green"
                    >Zur Standortsuche</a
                >
            </div>
        </div>
    </div>
`;
